import { Injectable } from "@angular/core";
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor } from "@angular/common/http";

import { Observable } from "rxjs";

import { environment } from 'src/environments/environment';
import { AuthService } from '../auth.service';


@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  constructor(private authService: AuthService) { }

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {

    if (request.url.startsWith(environment.apiBaseUrl)) {
      return next.handle(this.addCustomInfo(request));
    }
    return next.handle(request);
  }

  private addCustomInfo(request: HttpRequest<any>) {
    if (this.authService.isAuthenticated) {
      request = request.clone({
        setHeaders: {
          'X-EOS-UEI': `${this.authService.ActiveUser.employeeId}`,
          'X-EOS-UC': `${this.authService.ActiveUser.accessToken}`
        },
        withCredentials: true
      });
    }

    request = request.clone({
      setHeaders: {
        'Cache-Control': 'no-cache, no-store',
        Pragma: 'no-cache',
        Expires: '0'
      }
    });

    return request;
  }
}
